<template>
  <ReportChartWidget v-if="widgetType === 'report'" :data="data" />
  <BroadcastCardWidget v-else-if="widgetType === 'broadcast'" :data="data" />
  <AutomationCardWidget v-else-if="widgetType === 'automation'" :data="data" />
  <DashboardCardWidget v-else-if="widgetType === 'dashboard'" :data="data" />
  <div v-else class="awb-unsupported">
    {{ $t('Assistant.Widget.Unsupported', { type: widgetType }) }}
  </div>
</template>

<script>
import ReportChartWidget from './ReportChartWidget.vue'
import BroadcastCardWidget from './BroadcastCardWidget.vue'
import AutomationCardWidget from './AutomationCardWidget.vue'
import DashboardCardWidget from './DashboardCardWidget.vue'

// Dispatches a chat widget block to its renderer by widgetType. Adding a new widget type means
// adding a case here, not touching the chat composable or message-rendering markup.
export default {
  name: 'AssistantWidgetBlock',
  components: { ReportChartWidget, BroadcastCardWidget, AutomationCardWidget, DashboardCardWidget },
  props: {
    widgetType: { type: String, required: true },
    widgetId: { type: String, default: null },
    data: { type: [Object, Array], default: () => ({}) },
  },
}
</script>

<style scoped>
.awb-unsupported {
  padding: 8px 12px; border: 1px dashed var(--ui-border); border-radius: var(--radius-lg);
  font: 500 12px 'Open Sans', sans-serif; color: var(--ui-text-3);
}
</style>
